import React from 'react';
import { Filter, Lock, Repeat } from 'lucide-react';

/**
 * Компонент для отображения расширенных опций генератора
 */
const AdvancedOptionsSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4 mb-6 border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Filter className="w-5 h-5 mr-2 text-indigo-500" />
        Расширенные настройки
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Исключения чисел */}
        <div className="col-span-full">
          <label htmlFor="excludeValues" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Исключить числа (через запятую)
          </label>
          <input
            type="text"
            id="excludeValues"
            name="excludeValues"
            value={formData.excludeValues}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.excludeValues ? 'input-error' : ''}`}
            placeholder="Например: 13, 666, 42"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Эти числа не будут включены в результаты генерации
          </p>
          {errors.excludeValues && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.excludeValues}
            </p>
          )}
        </div>

        {/* Seed для воспроизводимости */}
        <div>
          <label htmlFor="seed" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Lock className="w-4 h-4 mr-2 text-indigo-500" />
            Seed для воспроизводимости
          </label>
          <input
            type="text"
            id="seed"
            name="seed"
            value={formData.seed}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.seed ? 'input-error' : ''}`}
            placeholder="Оставьте пустым для случайности"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Используйте одинаковый seed для получения одинаковых результатов
          </p>
          {errors.seed && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.seed}
            </p>
          )}
        </div>

        {/* Предотвращение повторений */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Repeat className="w-4 h-4 mr-2 text-indigo-500" />
            Предотвращение повторений
          </label>
          <div className="flex items-center h-10">
            <input
              type="checkbox"
              id="withoutRepetitions"
              name="withoutRepetitions"
              checked={formData.withoutRepetitions}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="withoutRepetitions" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Избегать последовательных повторений
            </label>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Предотвращает появление одинаковых чисел подряд
          </p>
        </div>

        {/* Отрицательные числа */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Отрицательные числа
          </label>
          <div className="flex items-center h-10">
            <input
              type="checkbox"
              id="allowNegative"
              name="allowNegative"
              checked={formData.allowNegative}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="allowNegative" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Разрешить отрицательные значения
            </label>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Применяется только если минимальное значение меньше нуля
          </p>
        </div>
      </div>

      {/* Информация о расширенных опциях */}
      <div className="mt-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-600 dark:text-gray-400">
          <span className="font-medium">Расширенные опции</span> позволяют более точно настроить генерацию случайных чисел. 
          Используйте seed для получения воспроизводимых результатов или исключите нежелательные числа из генерации.
        </p>
      </div>
    </div>
  );
};

export default AdvancedOptionsSection;